import { fontSizes } from '@enechain/ecloud-designsystem'

/** チャートの基準線マーカー (現在 / GC 等) の 1 個ぶんのラベル。 */
export type ChartMarker = {
  /** 並び順キー: 実時刻 "HH:MM"。昇順 (早い順) に左から並べる。 */
  time: string
  /** 表示文字列 (例: "現在" / "GC 17:30")。 */
  text: string
  /** 文字色 (どの基準線かは色で判別する)。 */
  color: string
}

/**
 * 現在線・GC 線などの基準線ラベルを「プロット直上の通常フロー行」として
 * 右揃えでまとめて表示する。
 *
 * 絶対配置 (チャート SVG への overlay) は右軸幅・目盛り・ヘッダ要素との衝突を
 * ピクセルオフセットの手調整で避ける必要があり、チャートごとに壊れやすい。
 * 通常フローの行にすればプロット外なので目盛りと重なり得ず、右端を
 * 「右軸幅 + 右マージン」(= rightOffset) で揃えれば上下チャートで必ず一致する。
 * 各線の位置は色 (現在=青 / GC=赤 等) で判別する。
 */
export const ChartMarkerLabels = ({
  markers,
  rightOffset,
}: {
  markers: ChartMarker[]
  /** プロット右端に合わせる右パディング px (= 右軸幅 + 右マージン)。 */
  rightOffset: number
}): React.ReactElement => {
  const sorted = [...markers].sort((a, b) => a.time.localeCompare(b.time))
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '6px',
        paddingRight: `${rightOffset}px`,
        // design スケールの xs (10px)。 raw DOM なので DS の fontSizes token の値で当てる
        fontSize: fontSizes.xs.value,
        fontWeight: 700,
        lineHeight: 1,
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      {sorted.map((m) => (
        <span key={m.text} style={{ color: m.color }}>
          {m.text}
        </span>
      ))}
    </div>
  )
}
